/* Prices come from Shopify in the customer's selected market, never a browser FX rate. */
(function () {
  'use strict';
  function allocate(total, weights) {
    var sum = weights.reduce(function (a, b) { return a + b; }, 0);
    if (!sum) return weights.map(function () { return 0; });
    var exact = weights.map(function (w) { return total * w / sum; });
    var result = exact.map(Math.floor);
    var remaining = total - result.reduce(function (a, b) { return a + b; }, 0);
    var order = exact.map(function (v, i) { return { i: i, fraction: v - result[i] }; });
    order.sort(function (a, b) { return b.fraction - a.fraction || a.i - b.i; });
    for (var i = 0; i < remaining; i++) result[order[i % order.length].i]++;
    return result;
  }
  function create(config) {
    var cache = new Map(), pending = new Map();
    function get(id) { return cache.get(String(id)); }
    function request(id) {
      id = String(id);
      if (cache.has(id)) return Promise.resolve(cache.get(id));
      if (pending.has(id)) return pending.get(id);
      var url = new URL(config.productUrl, window.location.origin);
      if (url.origin !== window.location.origin) return Promise.reject(new Error('Invalid price origin'));
      url.searchParams.set('variant', id);
      url.searchParams.set('section_id', 'gj-market-price');
      if (config.themeId) url.searchParams.set('preview_theme_id', config.themeId);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 12000);
      var promise = fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('Price unavailable'); return r.text(); })
        .then(function (html) {
          var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gj-market-price]');
          if (!node) throw new Error('Missing market price');
          var data = JSON.parse(node.textContent);
          if (String(data.variantId) !== id || String(data.productId) !== String(config.productId) ||
              data.currency !== config.currency || data.country !== config.country ||
              !Number.isSafeInteger(data.price) || data.price < 0) throw new Error('Market price mismatch');
          cache.set(id, data.price);
          return data.price;
        }).finally(function () { clearTimeout(timer); pending.delete(id); });
      pending.set(id, promise);
      return promise;
    }
    return { get: get, request: request };
  }
  window.GJMarketPricing = { create: create, allocate: allocate };
}());
